import React from 'react';
import { WorkflowState } from '../../../models/enums/WorkflowState';
import WorkflowStateBadge from '../../common/WorkflowStateBadge';
import './ProgressBarBig.css';
import AWSPortOpeningRequest from '../../../models/entities/AWSPortOpeningRequests';

interface ProgressBarBigProps {
	workflowState: WorkflowState;
	por: AWSPortOpeningRequest;
}

const ProgressBarBig = ({ workflowState, por }: ProgressBarBigProps) => {
	const hasProgressBar = (): boolean => {
		const noProgressArray = [WorkflowState.Cancelled, WorkflowState.Rejected];
		return !noProgressArray.some((nws) => nws.value === workflowState.value);
	};

	const activeAOApproval = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.PendingSolutionArchitectureApproval.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.PendingForCyberApproval.value:
			case WorkflowState.PendingForTechnicalReview.value:
			case WorkflowState.PendingTechnicalApproval.value:
			case WorkflowState.Error.value:
				return "big-back-blue";
			default:
				return "";
		}
	};

	const activeTechnicalApproval = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.PendingSolutionArchitectureApproval.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.PendingForCyberApproval.value:
			case WorkflowState.Error.value:
				return "big-back-blue";
			default:
				return "";
		}
	};

	const activeDOAGApproval = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.Error.value:
				return "big-back-blue";
			default:
				return "";
		}
	};

	const activeArchitectApproval = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.PendingForCyberApproval.value:
			case WorkflowState.PendingForCyberApproval.value:
			case WorkflowState.Error.value:
				return !por.architectApprovalBypassed() ? "big-back-blue" : "big-back-gray";
			default:
				return "";
		}
	};


	const activeCyberApproval = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.Error.value:
				return !por.cyberApprovalBypassed() ? "big-back-blue" : "big-back-gray";
			default:
				return "";
		}
	};

	return (
		<>
			<div className="big-progress-bar__title">
				<span className="em-c-field__label em-c-field__label--margin">Status</span>
				<WorkflowStateBadge workflowState={workflowState} />
			</div>
			{hasProgressBar() && (
				<div className="big-progress-bar">
					<div className="awsbig-progress-bar__line" />
					<div className="big-progress-bar__circle-with-title big-left-0">
						<div className={`big-progress-bar__circle ${activeAOApproval()}`}>✓</div>
						<div className="big-progress-bar__circle--title">AO Approval</div>
					</div>
					<div className="big-progress-bar__circle-with-title big-left-50">
						<div className={`big-progress-bar__circle ${activeTechnicalApproval()}`}>✓</div>
						<div className="big-progress-bar__circle--title">Technical Approval</div>
					</div>
					<div className="big-progress-bar__circle-with-title big-left-100">
						<div className={`big-progress-bar__circle ${activeArchitectApproval()}`}>✓</div>
						<div className="big-progress-bar__circle--title">Network Policy Sol. Arch. Approval</div>
					</div>
					<div className="big-progress-bar__circle-with-title big-left-150">
						<div className={`big-progress-bar__circle ${activeCyberApproval()}`}>✓</div>
						<div className="big-progress-bar__circle--title">Cyber Approval</div>
					</div>
					<div className="big-progress-bar__circle-with-title big-left-200">
						<div className={`big-progress-bar__circle ${activeDOAGApproval()}`}>✓</div>
						<div className="big-progress-bar__circle--title">DOAG Approval</div>
					</div>
				</div>
			)}
		</>
	);
};

export default ProgressBarBig;
